"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconWallet = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconWallet = function IconWallet(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 24,
    viewBox: "0 0 23 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M18.688 3.11c.73 0 1.343.538 1.425 1.25l.012.163v3.332h1.438c.792 0 1.437.63 1.437 1.41v11.403c0 .781-.645 1.414-1.438 1.414H2.875C1.289 22.082 0 20.816 0 19.258V5.934C0 4.457 1.16 3.23 2.66 3.12l.215-.012zm-.481 9.488a1.903 1.903 0 00-1.914 1.894c0 1.047.855 1.899 1.914 1.899a1.91 1.91 0 001.918-1.899c0-1.047-.86-1.894-1.918-1.894zm0-7.59H2.883a.956.956 0 00-.965.949c0 .523.43.95.965.95h15.324zm0 0"
  }));
};
exports.IconWallet = IconWallet;